"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
class BaseModel {
    constructor(mapper, data = {}, state) {
        this._mapper = mapper;
        if (!this._mapper || typeof this._mapper !== 'object')
            throw new Error('Only create models via the mapper');
        Object.keys(data).forEach(key => {
            this[key] = data[key];
        });
        if (!this.ID) {
            this.ID = (0, uuid_1.v4)();
        }
        this._state = state || 'new';
    }
    get ID() {
        return this._ID;
    }
    set ID(ID) {
        if (this._ID && this._ID !== ID) {
            throw new Error('cannot update ID');
        }
        this._ID = ID;
    }
    update(data) {
        this._mapper.validateUpdate(this, data);
        for (let i in data) {
            const readonly = this.constructor.readonly || [];
            if (!readonly.includes(i) && i !== 'ID') {
                this[i] = data[i];
            }
        }
    }
    isKeyAllowed(name) {
        return true;
    }
    serialize() {
        const string = {
            ID: this.ID
        };
        Object.keys(this).forEach(key => {
            if (typeof key !== 'function' &&
                key !== '_mapper' &&
                this.isKeyAllowed(key) &&
                key.substring(0, 1) !== '_') {
                string[key] = this[key];
            }
        });
        return string;
    }
    isDBKeyAllowed(name) {
        return true;
    }
    toDB() {
        const db = {
            ID: this.ID
        };
        Object.keys(this).forEach(key => {
            if (typeof key !== 'function' &&
                key !== '_mapper' &&
                this.isDBKeyAllowed(key) &&
                this[key] !== undefined &&
                key.substring(0, 1) !== '_') {
                db[key] = this[key];
            }
        });
        return db;
    }
    async preCommit() { }
    async preDelete() { }
    async commit(skipValidation) {
        await this.preCommit();
        this.cast();
        if (!skipValidation) {
            const error = await this.validate();
            if (error)
                return Promise.reject(error);
        }
        const result = await this._mapper.commit(this);
        this._state = 'loaded';
        return result;
    }
    async delete(hardDelete = true) {
        this.preDelete();
        const result = await this._mapper.delete(this, hardDelete);
        this._state = 'deleted';
        return result;
    }
    validate() {
        return this._mapper.validate(this);
    }
    cast() {
        //Set defaults + transformations
        //Only strip defaults if new model to keep fields that have been loaded from the db
        const castedObj = this._mapper.cast(this, this._state === 'new');
        Object.assign(this, castedObj);
        return castedObj;
    }
}
exports.default = BaseModel;
